import { InferType, object, string } from 'yup';

export interface DKPopupProps {
  open: boolean;
  handleClose: (create: boolean) => void;
  bannerData: any;
}

export const DKPopupSchema = object({
  email: string().email('You must enter a valid email').required('You must enter a valid email'),
  message: string()
    .trim()
    .min(5, 'Message should be at least 5 symbols')
    .required('Message is required'),
});

export type DKPopupIFormValues = InferType<typeof DKPopupSchema>;
